import { handleRequest } from './base';

// ManagerRepo is used to retrieve and store Managers
const ManagerRepo = {
  fetchCollection: (business) => handleRequest({
    method: 'get',
    url: `/business/${business.id}/managers`,
  }),

  create: (business, user) => handleRequest({
    method: 'post',
    url: `/business/${business.id}/managers`,
    data: user,
  }),

  delete: (business, userID) => handleRequest({
    method: 'delete',
    url: `/business/${business.id}/managers/${userID}`,
  }),
};

export default ManagerRepo;
